export default {"src":"/_next/static/media/package.13a484f5.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};